
export const RoundTripArrow: React.FC<React.SVGProps<SVGSVGElement>> = ({
    width = 24,
    height = 24,
    fill = '#1A1A1A',
    ...restProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...restProps}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.52019 19.8601C7.71902 20.1252 8.0951 20.1789 8.36019 19.9801C8.62528 19.7812 8.679 19.4051 8.48017 19.14L4.70017 14.1003L20.5002 14.1003C20.8316 14.1003 21.1002 13.8317 21.1002 13.5003C21.1002 13.1689 20.8316 12.9003 20.5002 12.9003L3.51809 12.9003C3.38681 12.8963 3.25312 12.9352 3.13993 13.0201C2.87483 13.2189 2.82112 13.595 3.01995 13.8601L7.52019 19.8601ZM3.49994 11.0998L20.482 11.0998C20.6133 11.1038 20.747 11.065 20.8602 10.9801C21.1253 10.7812 21.179 10.4051 20.9802 10.14L16.4799 4.14005C16.2811 3.87496 15.905 3.82124 15.6399 4.02007C15.3748 4.2189 15.3211 4.59498 15.5199 4.86008L19.3 9.89981L3.49994 9.89981C3.16857 9.89981 2.89994 10.1684 2.89994 10.4998C2.89994 10.8312 3.16857 11.0998 3.49994 11.0998Z"
            fill={fill}
        />
    </svg>
)

export default RoundTripArrow
